import { createContext, useContext, useState, useCallback } from 'react'

const AboutSiteContext = createContext(null)

export function AboutSiteProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false)

  const openAbout = useCallback(() => setIsOpen(true), [])
  const closeAbout = useCallback(() => setIsOpen(false), [])

  return (
    <AboutSiteContext.Provider value={{ isOpen, openAbout, closeAbout }}>
      {children}
    </AboutSiteContext.Provider>
  )
}

export function useAboutSite() {
  const ctx = useContext(AboutSiteContext)
  if (!ctx) throw new Error('useAboutSite must be used within AboutSiteProvider')
  return ctx
}
